import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
// Import packages
import React from 'react';
import PropTypes from 'prop-types';

// Import styles
import { _Attachment } from "../../../style";
import { _FileEntryList } from "../../styles";
import FileEntry from "./index";
var FileListing = function FileListing(_ref) {
  var files = _ref.files,
    removeFile = _ref.removeFile,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement(_FileEntryList, {
    "data-testId": dataTestId
  }, files === null || files === void 0 ? void 0 : files.map(function (file, idx) {
    return /*#__PURE__*/React.createElement(_Attachment, {
      key: "new-note-file-".concat(idx)
    }, /*#__PURE__*/React.createElement(FileEntry, {
      idx: idx,
      removeFile: removeFile
    }, file.name));
  }));
};
FileEntry.propTypes = {
  files: PropTypes.array,
  removeFile: PropTypes.func.isRequired
};
export default FileListing;